import { CurrencyPipe, NgClass } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { Plan } from 'app/models/pricing.model';
import { LicenseType } from 'app/models/signup.model';
import { PaymentService } from 'app/services/payment/payment.service';
import { SignupService } from 'app/services/signup/signup.service';
import { CVA_CONSTANTS } from 'app/util/constants';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'cva-standalone-subscription-pricing',
    standalone: true,

    imports: [
        MatButtonModule,
        FuseCardComponent,
        MatIconModule,
        CurrencyPipe,
        NgClass,
        RouterLink,
    ],
    templateUrl: './subscription-pricing.component.html',
    styleUrl: './subscription-pricing.component.scss',
})
export class SubscriptionPricingComponent implements OnDestroy {
    @Input() isHeaderFooterRequired = true;
    @Input() isToUpgrade = false;
    @Input() plansListing: Plan[] = [];

    private destroy$ = new Subject<void>();
    yearlyBilling = true;
    LicenseType = LicenseType;

    constructor(
        private _router: Router,
        private signupService: SignupService,
        private route: ActivatedRoute,
        private _paymentService: PaymentService
    ) {
        this.route.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            if (data.initialData as Plan[]) {
                this.plansListing = data.initialData as Plan[];
            }
        });
    }

    get productName(): string {
        return environment.productBy;
    }

    get currentYear(): number {
        return new Date().getFullYear();
    }

    onGetStarted(plan: Plan): void {
        if (!this.isToUpgrade) {
            this.signupService.updateSignupData({
                plan: plan.value,
                planIsYearly: this.yearlyBilling,
            });

                const signupData = this.signupService.getSignupData();

                const newSubscriptionObj = {
                    currency: CVA_CONSTANTS.CURRENCY.value,
                    isYearlyBilling: this.yearlyBilling,
                    planType: plan.value,
                    firstName: signupData.firstName,
                    lastName: signupData.lastName,
                    password: signupData.password,
                    email: signupData.email
                };

                this._paymentService
                    .createCheckoutSession(newSubscriptionObj)
                    .subscribe({
                        next: async (response) => {
                            window.open(response.url, '_self');
                        },
                        error: (error) => {
                            console.log(error);
                        },
                    });
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
